// extracted by mini-css-extract-plugin
export default {"control":"HeaderControls_control__mL3UN"};